import { AnnotationPlugin } from '@st/document-viewer-kit'
import { calculatorTapePlugin } from './calculator-tape'
import { commentToolPlugin } from './comment'
import { rectToolPlugin } from './rectangle'
import { selectToolPlugin } from './select'
import { signOffsPlugin } from './sign-offs'
import { textToolPlugin } from './text'
import { stampPlugin } from './stamp'
import { crossReferencesPlugin } from './cross-references'
import { checkmarkPlugin } from './checkmark'

export const ST_DOC_VIEWER_PLUGINS: AnnotationPlugin<any, any>[] = [
  calculatorTapePlugin(),
  commentToolPlugin(),
  rectToolPlugin(),
  selectToolPlugin(),
  // Most-specific stamp variants first
  checkmarkPlugin(),
  signOffsPlugin(),
  crossReferencesPlugin(),
  stampPlugin(),
  textToolPlugin()
]
